import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Compass, LogOut } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = (p) => location.pathname === p || location.pathname.startsWith(p + "/");

  const linkCls = (p) =>
    `text-[0.78rem] tracking-[0.18em] uppercase transition-colors ${
      isActive(p) ? "text-ink" : "text-muted-foreground hover:text-ink"
    }`;

  return (
    <header className="border-b border-stone bg-bone/80 backdrop-blur sticky top-0 z-40">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
        <Link to={user ? "/dashboard" : "/"} className="flex items-center gap-3" data-testid="nav-brand">
          <Compass size={20} strokeWidth={1.4} className="text-terracotta" />
          <span className="font-serif text-xl tracking-tight text-ink">Carolina Peer Institute</span>
        </Link>
        <nav className="flex items-center gap-8">
          {user && user.role === "trainee" && (
            <>
              <Link to="/dashboard" className={linkCls("/dashboard")} data-testid="nav-dashboard">Dashboard</Link>
              <Link to="/curriculum" className={linkCls("/curriculum")} data-testid="nav-curriculum">Curriculum</Link>
              <Link to="/generational-health" className={linkCls("/generational-health")} data-testid="nav-careers">Careers</Link>
            </>
          )}
          {user && user.role === "admin" && (
            <>
              <Link to="/admin" className={linkCls("/admin")} data-testid="nav-admin">Admin</Link>
              <Link to="/generational-health" className={linkCls("/generational-health")} data-testid="nav-careers-admin">Careers</Link>
            </>
          )}
          {!user && (
            <>
              <Link to="/curriculum-overview" className={linkCls("/curriculum-overview")} data-testid="nav-program">Program</Link>
              <Link to="/generational-health" className={linkCls("/generational-health")} data-testid="nav-careers-public">Careers</Link>
              <Link to="/login" className={linkCls("/login")} data-testid="nav-login">Sign in</Link>
              <Link to="/register" className="btn-primary !py-2 !px-4 text-xs" data-testid="nav-enroll">Enroll</Link>
            </>
          )}
          {user && (
            <button
              onClick={async () => { await logout(); navigate("/"); }}
              className="text-[0.78rem] tracking-[0.18em] uppercase text-muted-foreground hover:text-ink flex items-center gap-2"
              data-testid="nav-logout"
            >
              <LogOut size={14} strokeWidth={1.5} /> Sign out
            </button>
          )}
        </nav>
      </div>
    </header>
  );
}
